import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {logOut} from 'modules/authentication/actions';

import AuthenticationContainer from 'components/Authentication/Steps/AuthenticationContainer';
import Loading from 'components/Controls/Loading';

export default function Logout() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(logOut());
    }, [dispatch]);

    const containerStyles = {
        backgroundColor: 'white',
        minWidth: 350,
    };

    return <div style={containerStyles}>
        <AuthenticationContainer title="Logout" >
            <Loading text="Logging out ..." />
        </AuthenticationContainer>
    </div>
}